import TopNav from "@/components/founding/TopNav";
import Hero from "@/components/founding/Hero";
import StudioDescription from "@/components/founding/StudioDescription";
import Footer from "@/components/founding/Footer";
import SignupModal from "@/components/founding/SignupModal";
import LegalDisclaimerModal from "@/components/founding/LegalDisclaimerModal";
import { useFoundingEntry } from "@/hooks/useFoundingEntry";
import SeoHead from "@/components/seo/SeoHead";
import {
    PAGE_SEO,
    softwareApplicationSchema,
    organizationSchema,
} from "@/lib/seo";

// Multi-page architecture: the home page is a clean Hero entrypoint.
// Process Flow (/how-it-works), Examples (/examples), Pricing (/pricing),
// and Testimonials (/testimonials) all live on their own dedicated
// routes — see App.js.
export default function FoundingBeta() {
    const { modalOpen, setModalOpen, authMode, setAuthMode, onCtaClick, onSignIn, onSignUp } = useFoundingEntry();

    return (
        <main
            className="relative min-h-screen bg-black text-slate-100"
            data-testid="founding-beta-page"
        >
            <SeoHead
                {...PAGE_SEO.home}
                jsonLd={[softwareApplicationSchema(), organizationSchema()]}
            />
            <TopNav onSignIn={onSignIn} onSignUp={onSignUp} />
            <Hero onCtaClick={onCtaClick} />
            <div className="bg-black">
                <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-8 sm:py-10">
                    <StudioDescription testId="home-studio-description" />
                </div>
            </div>
            <Footer onCtaClick={onCtaClick} />
            <SignupModal
                open={modalOpen}
                onOpenChange={setModalOpen}
                mode={authMode}
                onModeChange={setAuthMode}
            />
            <LegalDisclaimerModal />
        </main>
    );
}
